import React, { useState } from 'react';
import Link from '../Link';
import logo from '../../Icons/logo.svg';
import searchIcon from '../../Icons/icons-search.svg';
import { getCtaUrl } from '../../../utils';
import DropdownItem from './DropdownItem';
import LinkItem from './LinkItem';
import { motion, useMotionValueEvent, useScroll } from 'framer-motion';

import './index.scss';

export default function Nav({ homepage = false, navData, setSearchEngineVisible, hideLinks = false }) {
  const navLinks = navData.mainMenu.nodes;

  const [expanded, setExpanded] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [scrolledUp, setScrolledUp] = useState(false);

  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, 'change', (latest) => {
    const previous = scrollY.getPrevious();
    const dynamicHeight = 350;

    if (latest > previous && latest > dynamicHeight) {
      setHidden(true);
      setScrolledUp(false);
    } else if (latest < previous) {
      setHidden(false);
      setScrolledUp(true);
    }

    if (scrollY.get() < dynamicHeight) {
      setScrolledUp(false);
    }
  });

  const groupedLinks = navLinks.reduce(
    (result, item) => {
      if (item.icon && item.icon.url) {
        result.withIcon.push(item);
      } else {
        result.withoutIcon.push(item);
      }
      return result;
    },
    { withIcon: [], withoutIcon: [] }
  );

  return (
    <motion.nav
      id={`${homepage ? 'homepage' : 'inner-page'}`}
      animate={hidden ? 'hidden' : 'visible'}
      variants={{
        visible: {
          y: 0,
          opacity: 1,
        },
        hidden: {
          y: '-100%',
          opacity: 0,
        },
      }}
      transition={{ duration: 0.35, ease: 'easeInOut' }}
      className={`ui-navbar ${expanded ? 'expanded' : ''}`}
      style={{
        backgroundColor: !homepage ? '#47B972' : scrolledUp ? '#47B972' : 'transparent',
        transition: 'background-color 0.35s ease-in-out',
      }}
    >
      <div className="container">
        <Link className="navbar-brand" to={'/'}>
          <img src={logo} alt="European Greens" />
        </Link>
        <button
          type="button"
          data-target="#navNav"
          aria-expanded={expanded}
          aria-controls="navNav"
          data-toggle="collapse"
          className={`navbar-toggler ${expanded ? 'expanded' : ''}`}
          aria-label="Toggle navigation"
          onClick={() => setExpanded((prev) => !prev)}
        >
          <span className={`${expanded ? 'open-toggle ' : ''} navbar-toggler-icon`} />
        </button>
        {!hideLinks && (
          <ul className={`nav-items ${expanded ? 'show' : ''}`} id="navNav">
            {groupedLinks?.withoutIcon.map((link) =>
              link.treeChildren.length === 0 ? (
                <LinkItem key={link.id} link={link?.content.slug} label={link?.title} isButton={link?.isButton} />
              ) : (
                <DropdownItem
                  key={link.id}
                  link={link?.content?.slug}
                  label={link?.title}
                  children={link?.treeChildren}
                />
              )
            )}

            <div className="nav-actions">
              <button
                onClick={() => setSearchEngineVisible(true)}
                style={{ cursor: 'pointer' }}
                className="search-nav-engine-btn"
              >
                <img src={searchIcon} alt="Search" />
              </button>

              {groupedLinks?.withIcon?.map((link) => (
                <Link key={link.id} to={getCtaUrl(link?.content.slug)}>
                  <img src={link.icon.url} alt={link.icon?.alt} />
                </Link>
              ))}
            </div>
          </ul>
        )}
      </div>
    </motion.nav>
  );
}
